import { ConfigModuleCategory } from 'library/ts/model/enums/config/ConfigModuleCategory';
import { ImportRole } from 'library/ts/model/enums/config/ImportRole';
import { ImportType } from 'library/ts/model/enums/config/ImportType';
import { Protocol } from 'library/ts/model/enums/net/Protocol';
import { Domain } from 'library/ts/model/enums/web/Domain';
import { SubDomain } from 'library/ts/model/enums/web/SubDomain';
import { Namespace } from 'library/ts/namespaces/Namespace';
import { TagConfigPluginSample } from 'plugins/tag/plugin_sample/ts/Application/model/config/TagConfigPluginSample';
import { ErrorCodeMap } from 'tag/ts/tag/model/error/ErrorCodeMap';
import { ErrorMessage } from 'tag/ts/tag/model/error/ErrorMessage';
import { ErrorStyle } from 'tag/ts/tag/model/error/ErrorStyle';
import { ErrorTemplate } from 'tag/ts/tag/model/error/ErrorTemplate';
import { ErrorUrl } from 'tag/ts/tag/model/error/ErrorUrl';
const projectInfo = window.PlayerServicesProjectInfo;
const urlPrefix = `${Protocol.HTTPS}://${SubDomain.PLAYER_SERVICES}.${Domain.CBSCOM}/`;
const basePlayerURL = `${urlPrefix}${projectInfo.dependencies.bundle.tag.dir.value}/${projectInfo.dependencies.bundle.tag.player.dir.output.value}/${projectInfo.dependencies.bundle.tag.player.version.player_version_token}/`;
export const DefaultTagConfig = {
    Imports: {
        category: ConfigModuleCategory.DEPENDENCY,
        enabled: true,
        params: {
            avia: {
                player: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.PLAYER,
                    namespace: projectInfo.dependencies.player.namespace.value,
                    url: {
                        regular: `${basePlayerURL}${projectInfo.dependencies.player.file_name.regular.value}`
                    },
                    order: 1
                },
                adapter_dash: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.PLAYER,
                    namespace: projectInfo.dependencies.player_dash_adapter.namespace.value,
                    url: {
                        regular: null
                    },
                    order: 2
                },
                plugin_gam: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.PLAYER,
                    namespace: projectInfo.dependencies.player_gam_plugin.namespace.value,
                    url: {
                        regular: null
                    },
                    order: 3
                },
                plugin_fw: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.PLAYER,
                    namespace: projectInfo.dependencies.player_fw_plugin.namespace.value,
                    url: {
                        regular: null
                    },
                    order: 4
                },
                adapter_hls: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.PLAYER,
                    namespace: projectInfo.dependencies.player_hls_adapter.namespace.value,
                    url: {
                        regular: null
                    },
                    order: 5
                },
                plugin_hlsjs: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.PLAYER,
                    namespace: projectInfo.dependencies.player_hlsjs_plugin.namespace.value,
                    url: {
                        regular: null
                    },
                    order: 6
                },
                plugin_shaka: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.PLAYER,
                    namespace: projectInfo.dependencies.player_shaka_plugin.namespace.value,
                    url: {
                        regular: null
                    },
                    order: 7
                },
                plugin_lg: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.PLAYER,
                    namespace: projectInfo.dependencies.player_lg_plugin.namespace.value,
                    url: {
                        regular: null
                    },
                    order: 8
                },
                plugin_samsung: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.PLAYER,
                    namespace: projectInfo.dependencies.player_samsung_plugin.namespace.value,
                    url: {
                        regular: null
                    },
                    order: 9
                },
                plugin_hdcp: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.PLAYER,
                    namespace: projectInfo.dependencies.player_hdcp_plugin.namespace.value,
                    url: {
                        regular: null
                    },
                    order: 10
                },
                plugin_xbox: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.PLAYER,
                    namespace: projectInfo.dependencies.player_xbox_plugin.namespace.value,
                    url: {
                        regular: null
                    },
                    order: 11
                },
                plugin_comcast: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.PLAYER,
                    namespace: projectInfo.dependencies.player_comcast_plugin.namespace.value,
                    url: {
                        regular: null
                    },
                    order: 12
                },
                player_ui: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.PLAYER_UI,
                    namespace: projectInfo.dependencies.player_ui.namespace.value,
                    url: {
                        regular: `$${basePlayerURL}${projectInfo.dependencies.player_ui.file_name.regular.value}`
                    },
                    order: 13
                }
            },
            low_level: {
                shaka: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.LOW_LEVEL_PLAYER,
                    namespace: null,
                    url: {
                        regular: null
                    },
                    order: 1
                },
                hlsjs: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.LOW_LEVEL_PLAYER,
                    namespace: null,
                    url: {
                        regular: null
                    },
                    order: 2
                }
            },
            ad_sdk: {
                ima: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.AD_SDK,
                    namespace: projectInfo.dependencies.ima.namespace.value,
                    url: {
                        regular: projectInfo.dependencies.ima.url.regular.value
                    },
                    order: 1
                },
                ima_dai: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.AD_SDK,
                    namespace: projectInfo.dependencies.ima_dai.namespace.value,
                    url: {
                        regular: projectInfo.dependencies.ima_dai.url.regular.value
                    },
                    order: 2
                }
            },
            smart_tag: {
                skin_css: {
                    enabled: true,
                    type: ImportType.STYLE,
                    role: ImportRole.SMART_TAG_SKIN,
                    namespace: undefined,
                    url: {
                        regular: `${urlPrefix}${projectInfo.app_output_dir.skin.value}/css/${projectInfo.app_output_file.skin.css.min.value}`
                    },
                    order: 1
                },
                skin: {
                    enabled: true,
                    type: ImportType.SCRIPT,
                    role: ImportRole.SMART_TAG_SKIN,
                    namespace: Namespace.DESKTOP_SKIN,
                    url: {
                        regular: `${urlPrefix}${projectInfo.app_output_dir.skin.value}/${projectInfo.app_output_file.skin.js.min.value}`
                    },
                    order: 2
                }
            }
        }
    },
    Hooks: {
        category: ConfigModuleCategory.HOOK,
        enabled: true,
        params: {
            PremiumAudioHook: {
                enabled: false
            },
            PreferredVideoCodecHook: {
                enabled: false
            }
        }
    },
    ErrorCopy: {
        category: ConfigModuleCategory.COPY,
        enabled: true,
        params: {
            templates: ErrorTemplate,
            style: ErrorStyle,
            url: ErrorUrl,
            message: ErrorMessage,
            map: ErrorCodeMap
        }
    },
    TagPluginSample: TagConfigPluginSample,
    ResourceConfigBuilder: {
        category: ConfigModuleCategory.RESOURCE,
        enabled: true,
        params: {
            ads: {
                enabled: true
            }
        }
    }
};
